export function getStepInfo(steps, stepId) {
  return Object.values(steps).find((s) => String(s.step_id) === stepId)
}
